import { callApi } from "./index"

const API_URL: string = "/api/easydirectoryapi/get-logged-in-user-details";

export const getUserProfile = (): Promise<UserDetails> => {
  return callApi(API_URL, { })
}

export const getUserProfileNoCache = (): Promise<UserDetails> => {
  return callApi(`${API_URL}?clear=true`, { })
}

export interface UserDetails {  
  DisplayName: string, 
  ProfileImage: string,
  FirstName: string,
  LastName: string,
  Email: string,
  WeddingDate?: string,
  City?: string,
  UserId?: string,
  Postcode?: string,
  IsConciergeChannelCreated?: boolean,
  RegionId?: number,
  WedPointsBalance: number,
  Phone?: string,
  Guests?: number,
  PartnerFirstName?: string,
  PartnerLastName?: string,
  BookedVenueSupplierId?: number,
  BookedVenueSupplierName?: string,
  HasCompletedOnboarding: boolean,
  IsDestinationWedding: boolean,
  DestinationWeddingRegionId?: number,
  DestinationWeddingRegionName?: string,
}

